'use strict';

module.exports = {
  silentJSONParsing: true,
  forcedJSONParsing: true,
  clarifyTimeoutError: false
};



/*****************
 ** WEBPACK FOOTER
 ** ./~/axios/lib/defaults/transitional.js
 ** module id = ./node_modules/axios/lib/defaults/transitional.js
 ** module chunks = 0
 **/